<app-multiple-select-filter
        [elements]="elements"
        [filterElementProcessor]="filterElementProcessor"
        [loading]="loading"
        [newItemModalOptions]="newItemModalOptions"
        [noEntriesFoundLabel]="noEntriesFoundLabel"
        [parentFormControlName]="parentFormControlName"
        [parentFormGroup]="parentFormGroup">
    <ng-template let-element='element' template-content>
        <ng-container [ngTemplateOutletContext]="{element:element}" [ngTemplateOutlet]="template"></ng-container>
    </ng-template>
</app-multiple-select-filter>
